"use client";

import { WavyBackground } from "@/components/wavy-background";
import { cn } from "@/lib/utils";
import { PropsWithClassName } from "@/types";
import { useTheme } from "next-themes";
import { PropsWithChildren } from "react";

export function LandingPageWave(props: PropsWithChildren<PropsWithClassName>) {
  const { resolvedTheme } = useTheme();

  return (
    <section id="systems">
      <WavyBackground
        className="container flex max-w-4xl flex-col items-center justify-center gap-12"
        blur={20}
        speed="slow"
        waveWidth={50}
        waveOpacity={0.3}
        backgroundFill={
          resolvedTheme === "dark" ? "hsl(240 5% 6%)" : "hsl(0 0% 100%)"
        }
        containerClassName={cn("bg-background py-20 md:py-32", props.className)}
        colors={["#FFB300", "#496B38", "#811D1D"]}
      >
        {props.children}
      </WavyBackground>
    </section>
  );
}
